import { Component, Input } from '@angular/core';
import { RingoverService } from '../../services/ringover.service';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-ringover-widget',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './ringover-widget.component.html',
  styleUrls: ['./ringover-widget.component.css']
})
export class RingoverWidgetComponent {
  @Input() telephone: string = '';
  
  isSmsModalOpen: boolean = false;
  smsMessage: string = '';
  isCalling: boolean = false;
  isSendingSms: boolean = false;

  constructor(private ringoverService: RingoverService) {}

  openSmsModal() {
    if (!this.telephone) {
      alert("Veuillez renseigner un numéro de téléphone valide.");
      return;
    }
    this.isSmsModalOpen = true;
  }

  closeSmsModal() {
    this.isSmsModalOpen = false;
    this.smsMessage = '';
  }

  sendSms() {
    if (!this.smsMessage.trim()) return;
    
    this.isSendingSms = true;
    this.ringoverService.sendSms({ toNumber: this.telephone, message: this.smsMessage }).subscribe({
      next: (res) => {
        alert("SMS envoyé avec succès.");
        this.isSendingSms = false;
        this.closeSmsModal();
      },
      error: (err) => {
        alert("Erreur lors de l'envoi du SMS. Vérifiez votre configuration Ringover.");
        this.isSendingSms = false;
        console.error(err);
      }
    });
  }
}
